import { render, staticRenderFns } from "./SofortHeader.vue?vue&type=template&id=4df0fbec&scoped=true&"
import script from "./SofortHeader.vue?vue&type=script&lang=js&"
export * from "./SofortHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../nodevenv/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/16/lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4df0fbec",
  null
  
)

export default component.exports